export default __webpack_public_path__ + "static/media/origin location.5c543846.svg";